import React from 'react';
import { Highlight } from './LetsHealTogether';
import {
  LetsHealTogetherHighlightIcon,
  LetsHealTogetherHighlightText,
  LetsHealTogetherHighlightWrapper,
} from './LetsHealTogetherHighlight.style';

export const LetsHealTogetherHighlight: React.FC<Highlight> = ({ text, iconUrl }) => (
  <LetsHealTogetherHighlightWrapper>
    <LetsHealTogetherHighlightIcon src={iconUrl} />
    <LetsHealTogetherHighlightText>{text}</LetsHealTogetherHighlightText>
  </LetsHealTogetherHighlightWrapper>
);
